import React, { useEffect, useRef, useState } from 'react'
import { makeStyles } from '@mui/styles'
import { Grid, Theme } from '@mui/material';
import "../css/receivefunds.css"
import CurrencyInput from 'react-currency-input-field';
import AuthCode, { AuthCodeRef } from 'react-auth-code-input';




const useStyles = makeStyles((theme: Theme)=>{
    return {
        navIcon: {
            color: '#999 !important',
            fontSize: '1.7rem !important',
            fontWeight: '900 !important'
        },
        logo: {
            transition: 'height 0.4s ease 0s, opacity 0.3s ease 0s',
            margin:'0 auto'
        },
        logoHolder: {
          width: '100%',
          display: 'flex',
          justifyContent:'center',
          alignItems: 'center'
        },
        paragraph: {
          lineHeight: 1.6,
          color: '#555',
          fontSize: '0.978rem',
          fontStyle: 'normal',
          textAlign: 'left',
          fontWeight: '400',
          marginBottom: '30px'
      },
      footer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '1rem',
        [theme.breakpoints.down('md')]: {
          padding: '0rem',
        },
      },
      linkButton: {
        color: '#fff !important',
        backgroundColor: '#5d307f',
        borderColor: '#5d307f',
        marginLeft: '10px',
        display: 'inline-block',
        fontWeight: 400,
        textAlign: 'center',
        whiteSpace: 'nowrap',
        verticalAlign: 'middle',
        userSelect: 'none',
        border: '1px solid transparent',
        padding: '0.375rem 0.75rem',
        fontSize: '1rem',
        lineHeight: 1.5,
        borderRadius: '0.25rem',
        textDecoration: 'none',
        transition: 'all 0.15s ease-in-out',

        "&:hover": {
          color: '#000 !important',
          backgroundColor: '#e37927',
          borderColor: '#e37927',
        },

        [theme.breakpoints.down('sm')]: {
          marginLeft: '0',
          marginTop: '5px',
          display: 'block'
        },
      },
      asideInner: {
        padding: '1rem',
        width: '100%',
        height: '100%',

        [theme.breakpoints.down('md')]: {
          padding: '1rem',
        },
      }
    }
})


interface Props{
    handleChangePinClose: ()=> void
    lunchSomethingWrong: ()=> void
}

const ChangePin: React.FC<Props> = ({handleChangePinClose, lunchSomethingWrong}) => {
  const classes = useStyles()
  const authCodeRef = useRef<AuthCodeRef>(null);
  const authCodeRef2 = useRef<AuthCodeRef>(null);
  const authCodeRef3 = useRef<AuthCodeRef>(null);


  const [result, setResult] = useState('');
  const handleOnChange = (res: string) => {
    setResult(res);
  };


 const cancelTransaction =()=>{
    handleChangePinClose()
    authCodeRef.current?.clear();
    authCodeRef2.current?.clear();
    authCodeRef3.current?.clear();
 }

   const handleProceed =()=>{
      lunchSomethingWrong()
      authCodeRef.current?.clear();
      authCodeRef2.current?.clear();
      authCodeRef3.current?.clear();
    }

  return (
    <div id='sidebar-wrapper-change-pin-setting' className='sidebar-wrapper-receive-funds'>
        
        <div className='sidebar-receive-funds-beneficiariesmodal-dialog modal-dialog-scrollable modal-dialog-420-important'>
            <aside className='sidebar-receive-funds-beneficiaries' style={{padding: '0 0.6rem'}}>
                
            <div className='limit-transaction-header'>
              <h6 className="limit-transaction-header-h6">Change Transaction Pin</h6>
            </div>


            <div className='funds-beneficiaries-body'>
              <div style={{margin: '1rem 0'}}>

                <div style={{textAlign: 'center', marginBottom: '1.4rem'}}>
                    <label className="custom-large-badge-limit-trasacation-label" style={{padding: '0rem 0', color: '#555'}}>Current Pin</label>

                    <AuthCode ref={authCodeRef} containerClassName='pin-input' length={4} onChange={handleOnChange} />
                </div>


                <div style={{textAlign: 'center', marginBottom: '1.4rem'}}>
                    <label className="custom-large-badge-limit-trasacation-label" style={{padding: '0rem 0', color: '#555'}}>New Pin</label>

                    <AuthCode ref={authCodeRef2} containerClassName='pin-input' length={4} onChange={handleOnChange} />
                </div>


                <div style={{textAlign: 'center', marginBottom: '1.4rem', color: '#555'}}>
                    <label className="custom-large-badge-limit-trasacation-label" style={{padding: '0rem 0', color: '#555'}}>Confirm New Pin</label>

                    <AuthCode ref={authCodeRef3} containerClassName='pin-input' length={4} onChange={handleOnChange} />
                </div>


                <div style={{marginBottom: '3rem', height: '100%'}}>
                  <div style={{position: 'relative', overflow: 'hidden'}}>
                
                        <div className="pin-input-past-wrapper">
                            <button type="button" className="btn groom-panel-2-content-text-btn-change-pin-1" onClick={cancelTransaction}>Cancel</button>
                            <button type="button" className="btn groom-panel-2-content-text-btn-change-pin-2" onClick={handleProceed}>Proceed</button>
                        </div>

                  </div>
                </div>
              </div>
            </div>





                
            </aside>
        </div>
    </div>
  )
}

export default ChangePin
